import { Controller } from "@hotwired/stimulus";

// Canvas workflow (type n8n) : gère l'affichage du bon panneau de configuration
// (déclencheur / ajout d'action) selon le nœud sélectionné sur le canvas.
export default class extends Controller {
  static targets = ["triggerPanel", "addPanel", "emptyPanel", "node"];

  connect() {
    this.showEmpty();
  }

  showTrigger() {
    this.toggle("trigger");
    this.markSelected("trigger");
  }

  showAdd() {
    this.toggle("add");
    this.markSelected("add");
  }

  showEmpty() {
    this.toggle("empty");
    this.markSelected(null);
  }

  toggle(which) {
    if (this.hasTriggerPanelTarget) this.triggerPanelTarget.hidden = which !== "trigger";
    if (this.hasAddPanelTarget) this.addPanelTarget.hidden = which !== "add";
    if (this.hasEmptyPanelTarget) this.emptyPanelTarget.hidden = which !== "empty";
  }

  markSelected(which) {
    this.nodeTargets.forEach((n) => n.classList.toggle("is-selected", n.dataset.node === which));
  }
}
